import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import styles from './styles.module.scss';

const ApplyAndClearBlock = ({ onApply, onClear }) => (
	<div className={styles.ApplyAndClearBlock}>
		<Button
			className={styles.ApplyAndClearBlock__ClearButton}
			icon="close"
			onClick={onClear}
		/>
		<Button
			className={styles.ApplyAndClearBlock__ApplyButton}
			type="button"
			width="full"
			onClick={onApply}
			title="Применить"
		/>
	</div>
);

ApplyAndClearBlock.propTypes = {
	onApply: PropTypes.func,
	onClear: PropTypes.func
};

export default ApplyAndClearBlock;
